import React from 'react';
import '../LandingPage.css'; // Assuming styles are still here

function HeroSection() {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h2>Expert Software Development Solutions</h2>
        <p>Building robust web applications tailored to your needs.</p>
        <a href="#about" className="cta-button">Learn More</a>
      </div>
    </section>
  );
}

export default HeroSection;
